<template>

  <div class="c-shape-wrapper">

    <svg class="u-hidden-visually">
      <defs>
        <path id="shape-1" d="M494.5,182.1c0,138.1-108.9,246.6-247,246.6S0.5,327.9,0.5,189.9S112.4,0.5,250.5,0.5S494.5,44,494.5,182.1z" style="transform: scaleX(1) scaleY(1) translateX(0px) translateY(0px) rotate(0deg);"></path>
        <path id="shape-2" d="M477.7,199.8c0,138.1,13.9,246.6-124.2,246.6S0.5,275.4,0.5,137.3S92.7,0.5,230.8,0.5S477.7,61.8,477.7,199.8z" style="transform: scaleX(1) scaleY(1) translateX(0px) translateY(0px) rotate(0deg);"></path>
        <path id="shape-3" d="M489.6,224.5c0,135.7-121.3,300.4-236.5,228.8C152.5,390.7,0.5,360.2,0.5,224.5s107.7-224,243.4-224 S489.6,88.8,489.6,224.5z" style="transform: scaleX(1) scaleY(1) translateX(0px) translateY(0px) rotate(0deg);"></path>
      </defs>

    </svg>

    <div class="c-shape"
    :class="`c-shape--${type}`"
    ref="shape"
    >
    <svg class="c-shape__svg" width="500px" :height="slider ? '300px' : '500px'" :viewBox="slider ? '0 0 510 305' : link ? '-50 -50 600 600' : '0 0 510 510'">
      <clipPath :id="id">
        <path class="item__clippath" :id="`shape-front-${uid}`" :d="shapeFront" style="transform: scaleX(1) scaleY(1) translateX(0px) translateY(0px) rotate(0deg);"></path>
        <animate v-if="!isMobile"
                :xlink:href="`#shape-front-${uid}`"
                 attributeName="d"
                 attributeType="XML"
                 :from="shapeFront"
                 :to="shapeFrontAnim"
                 dur="6s"
                 repeatCount="indefinite"
                 keyTimes="0;0.5;1"
                 :values="`${shapeFront};${shapeFrontAnim};${shapeFront}`"
                 fill="freeze" />
      </clipPath>
      <g v-if="bg" class="c-shape__deco" style="transform: scaleX(1) scaleY(1) translateX(0px) translateY(0px) rotate(0deg);">
        <path :fill="`#${color}`" :id="`shape-bg-${uid}`" :d="shapeBg" />
        <animate v-if="!isMobile"
                :xlink:href="`#shape-bg-${uid}`"
                 attributeName="d"
                 attributeType="XML"
                 :from="shapeBg"
                 :to="shapeBgAnim"
                 dur="16s"
                 repeatCount="indefinite"
                 keyTimes="0;0.5;1"
                 :values="`${shapeBg};${shapeBgAnim};${shapeBg}`"
                 fill="freeze" />
      </g>
      <g class="c-shape__wrapper" :clip-path="`url(#${id})`">
        <image v-if="img" class="c-shape__img" :xlink:href="img.srcSet[0].url" x="0" y="0" height="100%" width="100%" style="transform: scaleX(1) scaleY(1) translateX(0px) translateY(0px) rotate(0deg);"></image>
        <path v-if="imgOverlay" class="c-shape__fill" d="M497.5,497.5H0V0h497.5V497.5z" style="transform: scaleX(1) scaleY(1) translateX(0px) translateY(0px) rotate(0deg);"></path>
      </g>
    </svg>
  </div>
</div>

</template>

<script>
import anime from 'animejs'

export default {
  name: 'Shape',
  props: ['img', 'imgOverlay', 'bg', 'id', 'type', 'color', 'link', 'slider'],

  data () {
    return {
      shapes: [
        'M250.5,488 C381.667628,488 488,381.667628 488,250.5 C488,119.332372 381.667628,13 250.5,13 C119.332372,13 13,119.332372 13,250.5 C13,381.667628 119.332372,488 250.5,488 Z',
        'M250.5,488 C488,480.9375 488,381.667628 488,250.5 C488,119.332372 295.417969,69.21875 182.867187,20.0234375 C70.3164062,-29.171875 13,119.332372 13,250.5 C13,381.667628 13,495.0625 250.5,488 Z',
        'M357.745522,478.507247 C488.91315,478.507247 483.658743,355.046225 483.658743,192.100828 C483.658743,29.1554301 250,54.5072471 144.02188,13 C38.0437601,-28.5072471 -16.8523666,93.2655126 15.6169048,192.100828 C48.0861762,290.936143 226.577894,478.507247 357.745522,478.507247 Z',
        'M318,488 C429.867485,488 555.130684,171.27461 458.111609,107.725331 C361.092534,44.1760528 381.667628,13 250.5,13 C119.332372,13 0.132376411,-8.33558527 12.6931093,194.344043 C25.2538421,397.023672 206.132515,488 318,488 Z',
        'M250.5,488 C484.399363,443.602259 446.334798,211.677982 484.399363,133.025235 C522.463927,54.3724874 381.667628,13 250.5,13 C119.332372,13 2.68792888,15.5814266 15.8349567,143.425598 C28.9819846,271.269769 16.6006375,532.397741 250.5,488 Z',
        'M139.163771,431.984697 C195,534.203953 464.506507,521.87264 486.365114,322.576954 C508.223721,123.281267 423.408503,-29.1681757 250.5,13 C77.5914969,55.1681757 15.0158069,80.6505549 15.0158069,211.818183 C15.0158069,342.985811 83.3275415,329.76544 139.163771,431.984697 Z',
        'M250.5,488 C433.828893,513.664511 488.672965,287.392882 488.672965,192.202792 C488.672965,97.0127023 334.375419,0 120.58805,13 C-93.1993197,26 92.5414818,276.21504 31.8854416,344.473797 C-28.7705987,412.732554 67.1711071,462.335489 250.5,488 Z',
        'M250.5,436.617702 C372.8893,305.727345 488,381.667628 488,250.5 C488,119.332372 471.482008,13 250.5,13 C29.5179924,13 13,75.9361332 13,250.5 C13,425.063867 128.1107,567.508058 250.5,436.617702 Z',
        'M271.653764,465.690286 C524.213076,394.39809 488.232407,245.257022 488.232407,177.488062 C488.232407,109.719102 463.545593,13 250.5,13 C37.4544068,13 110.951582,153.896062 45.764501,263.749899 C-19.4225799,373.603736 19.0944518,536.982482 271.653764,465.690286 Z',
        'M298.164877,488 C516.929381,512.240664 468.317879,383.130327 468.317879,251.962699 C468.317879,120.795071 567.83508,13 336.694654,13 C105.554227,13 -16.7113037,140.924548 27.099036,250 C70.9093757,359.075452 79.4003726,463.759336 298.164877,488 Z',
        'M166.348964,454.423226 C184.632446,562.052965 485.121373,365.175802 485.121373,234.008174 C485.121373,102.840546 433.737716,13 355.282524,13 C276.827333,13 -5.74328211,35.7940448 13,250.5 C31.7432821,465.205955 148.065482,346.793486 166.348964,454.423226 Z',
        'M209.627507,488 C347.559775,476 471.242527,476 488,250.5 C504.757473,25 410.293339,37.6338421 200.132077,13 C-10.0291855,-11.6338421 93.7088019,74.5166038 28.7937391,232.774482 C-36.1213236,391.03236 71.6952377,500 209.627507,488 Z',
        'M250.5,477.724704 C432.406202,438.649257 488,408.255121 488,250.5 C488,92.744879 456.013703,-19.8039485 250.5,13 C44.9862967,45.8039485 155.492912,228.963564 47.4935516,293.131002 C-60.5058089,357.298439 68.5937985,516.800152 250.5,477.724704 Z',
        'M298.519268,465.71203 C518.517075,369.081694 410.63847,305.583397 469.997807,203.319531 C529.357144,101.055665 489.179669,-1.98880912 252.179669,23.377952 C15.1796687,48.7447131 13.3441112,72.1519033 13.3441112,203.319531 C13.3441112,334.487159 78.5214614,562.342366 298.519268,465.71203 Z'

        // 'M494.5,182.1c0,138.1-108.9,246.6-247,246.6S0.5,327.9,0.5,189.9S112.4,0.5,250.5,0.5S494.5,44,494.5,182.1z',
        // 'M477.7,199.8c0,138.1,13.9,246.6-124.2,246.6S0.5,275.4,0.5,137.3S92.7,0.5,230.8,0.5S477.7,61.8,477.7,199.8z',
        // 'M461.7,232.8c0,135.7-56.1,215.4-191.7,215.4S0.5,355.9,0.5,220.3S0.8,0.5,136.5,0.5S461.7,97.1,461.7,232.8z',
        // 'M489.3,153.1c0,135.7-107.4,338.7-243.1,338.7S0.5,381.8,0.5,246.2S110.5,0.5,246.2,0.5S489.3,17.4,489.3,153.1',
        // 'M454.1,246.2c0,135.7-110,231.3-245.7,231.3S0.5,381.8,0.5,246.2S72.8,0.5,208.4,0.5S454.1,110.5,454.1,246.2z',
        // 'M486.3,246.2c0,135.7-221.6,213.6-357.3,213.6S0.6,310.7,0.6,175.1S104.9,0.5,240.6,0.5S486.3,110.5,486.3,246.2z'
      ],
      shapesSlider: [
        'M483.9,146.5c0,41.3-29.3,32.7-74.9,59.3c-43.5,25.3-101.7,86.7-166.8,86.7c-64.1,0-114.8-32.3-158.1-56.9 C37.2,209,0.5,188.4,0.5,146.5c0-43.4,53.6-52.5,103.3-79.3c42.7-22.9,76.7-66.7,138.4-66.7C307,0.5,365.9,15.9,409.3,41 C455.3,67.6,483.9,105,483.9,146.5z',
        'M483.9,146.5c0,41.3-29.3,32.7-74.9,59.3c-43.5,25.3-101.7,86.7-166.8,86.7c-64.1,0-114.8-32.3-158.1-56.9 C37.2,209,0.5,188.4,0.5,146.5c0-43.4,53.6-52.5,103.3-79.3c42.7-22.9,76.7-66.7,138.4-66.7C307,0.5,365.9,15.9,409.3,41 C455.3,67.6,483.9,105,483.9,146.5z'
      ],
      shapeFront: null,
      shapeFrontAnim: null,
      shapeBg: null,
      shapeBgAnim: null,
      uid: null
    }
  },

  beforeMount () {
    this.uid = this._uid
    this.getRandomShape()
  },

  mounted () {
    // Don't the active animations on mobile devices
    if (!this.isMobile) {
      this.initEvents(this.$refs.shape)
    }
  },

  updated () {
    if (!this.isMobile) {
      this.initEvents(this.$refs.shape)
    }
  },

  methods: {
    getRandomShape () {
      const shapes = this.slider ? this.shapesSlider : this.shapes
      const max = shapes.length
      const random = this.getRandomWithOneExclusion(max, null)
      const randomWithExclude = this.getRandomWithOneExclusion(max, random)

      this.shapeFront = shapes[random]
      this.shapeFrontAnim = shapes[randomWithExclude]

      // BG
      const randomBg = this.getRandomWithOneExclusion(max, null)
      const randomBgWithExclude = this.getRandomWithOneExclusion(max, randomBg)

      this.shapeBg = shapes[randomBg]
      this.shapeBgAnim = shapes[randomBgWithExclude]
    },

    getRandomWithOneExclusion (lengthOfArray, indexToExclude) {
      var rand = null

      while (rand === null || rand === indexToExclude) {
        rand = Math.round(Math.random() * (lengthOfArray - 1))
      }

      return rand
    },

    initEvents (el) {
      if (el.querySelector('.c-shape__deco') !== null) this.decoAnimation(el.querySelector('.c-shape__deco'))

      this.mouseenterFn = () => {
        this.isActive = true
        // this.shapeFrontAnim = this.shapeFront
        // this.shapeBgAnim = this.shapeBg
        // this.animate(el)
      }
      this.mouseleaveFn = () => {
        if (this.isActive) {
          this.isActive = false
          // this.getRandomShape()
          // this.animate(el)
        }
      }

      if (this.link) {
        el.addEventListener('mouseenter', this.mouseenterFn)
        el.addEventListener('mouseleave', this.mouseleaveFn)
        // el.addEventListener('touchstart', this.mouseenterFn)
        // el.addEventListener('touchend', this.mouseleaveFn)
      }

      this.decoAnimation(el.querySelector('.item__clippath'), 'reverse')
      // this.imgAnimation(el.querySelector('.c-shape__img'), 'reverse')
    },

    getAnimeObj (targetStr, el) {
      let target = el
      if (targetStr !== '') {
        target = el.querySelector(targetStr)
      }

      let animeOpts = {
        targets: target,
        duration: 3000,
        delay: targetStr === 'image' ? 0 : 100,
        easing: 'easeOutElastic',
        elasticity: 200,
        scaleX: this.isActive ? 1 : 1,
        scaleY: this.isActive ? 1 : 1,
        translateX: this.isActive ? 0 : 0,
        translateY: this.isActive ? 0 : 0,
        rotate: this.isActive ? 0 : 0
      }

      if (targetStr === 'path') {
        animeOpts.d = this.isActive ? this.shapeFrontAnim : this.shapeFront
      } else if (targetStr === '') {
        animeOpts.d = this.isActive ? this.shapeFrontAnim : this.shapeFront
      }

      anime.remove(target)
      return animeOpts
    },

    decoAnimation (el, type) {
      // const target = el
      // let animeOpts = {
      //   targets: target,
      //   duration: 5000,
      //   delay: 0,
      //   easing: 'linear',
      //   scaleX: 1,
      //   scaleY: 1,
      //   direction: 'alternate',
      //   loop: true
      // }
      // anime(animeOpts)

      // this
          // const path = type ? el : el.querySelector('path')
          // let pathAnimeOpts = {
          //   targets: path,
          //   duration: 8000,
          //   delay: 0,
          //   easing: 'linear',
          //   d: this.shapeBgAnim,
          //   direction: 'alternate',
          //   loop: true
          // }
          // anime(pathAnimeOpts)
      },

    // imgAnimation (el, type) {
      // const target = el
      // let animeOpts = {
      //   targets: target,
      //   duration: this.img.noAnimate ? 0 : 10000,
      //   delay: 0,
      //   easing: 'linear',
      //   scaleX: this.img.noAnimate ? 1 : 1.1,
      //   scaleY: this.img.noAnimate ? 1 : 1.1,
      //   direction: 'alternate',
      //   loop: true
      // }
      // anime(animeOpts)
    // },

    animate (el) {
      const options = this.getAnimeObj('path', el)
      anime(options)

      // const optionsImage = this.getAnimeObj('image', el)
      // anime(optionsImage)

      // const overlay = el.querySelector('.c-shape__fill')
      // if (overlay !== null) {
      //   const overlayAnim = this.getAnimeObj('', overlay)
      //   anime(overlayAnim)
      // }
    }
  },

  computed: {
    isMobile: () => {
      return window.innerWidth <= 768
    }
  }

}
</script>
